// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type TagFilledIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from tag-filled.svg
 */
export default function TagFilledIcon(props: TagFilledIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="TagFilledIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M7.563.174A1 1 0 0 0 7 0H1L.883.007A1 1 0 0 0 0 1v6l.007.121a1 1 0 0 0 .329.626l9 8 .098.078a1 1 0 0 0 1.38-.244l5-7 .067-.107a1 1 0 0 0-.223-1.227l-8-7zM3 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
        />
      </g>
    </svg>
  );
}
